import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-white overflow-y-auto"
}
const _hoisted_2 = { class: "custom-full" }
const _hoisted_3 = { class: "rounded-lg lg:pb-5" }
const _hoisted_4 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component')
}
const _hoisted_5 = {
  key: 1,
  class: "flex lg:flex-row items-center justify-center flex-col bg-[#2B2C32] rounded-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_List = _resolveComponent("List")!

  return (_ctx.vg_selectedLocation.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass('p-3 flex content-main ' + (_ctx.action.component ? ' half-it gap-5' : 'gap-5'))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex justify-between mt-2 h-[40px]" }, [
                _createElementVNode("h2", { class: "text-white font-semibold text-[24px]" }, "Payment Terminals")
              ], -1)),
              _createVNode(_component_List, {
                selectedItemCallback: _ctx.selectedItem,
                addComponent: _ctx.openAddComponent,
                clearComponent: _ctx.clearComponent,
                iscomponentactive: _ctx.action.component ? true : false
              }, null, 8, ["selectedItemCallback", "addComponent", "clearComponent", "iscomponentactive"])
            ])
          ]),
          (_ctx.action.component)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
                  item: _ctx.action.data,
                  clearComponent: _ctx.clearComponent
                }, null, 8, ["item", "clearComponent"]))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "w-full" }, [
          _createElementVNode("div", { class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]" }, [
            _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location.")
          ])
        ], -1)
      ]))]))
}